import React from 'react'

interface CheckboxEmptyProps {
  size?: number
  className?: string
}

export const CheckboxEmpty: React.FC<CheckboxEmptyProps> = ({
  size = 24,
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.75"
        y="0.75"
        width="22.5"
        height="22.5"
        rx="7.25"
        fill="transparent"
        stroke="#E5E7EB"
        strokeWidth="1.5"
      />
    </svg>
  )
}
